// App composition root infra. registerModule() turns a module's route
// descriptors into guarded <Route> elements, preserving the exact auth/billing
// behavior the app had before the modular refactor. This file (and App.jsx) are
// the ONLY places allowed to import module public entry points.
import { Route } from "react-router-dom";
import RequireAuth from "./shared/components/RequireAuth.jsx";
import RequireBilling from "./shared/components/RequireBilling.jsx";
import RequireWorkspaceAdmin from "./shared/components/RequireWorkspaceAdmin.jsx";
import { RequireSuperAdmin } from "./modules/admin/index.js";

// roles: ['admin','user']      -> authenticated product users (auth + billing gate)
//        ['workspace_admin']   -> the customer's own owner/admin (auth + billing + workspace-admin gate)
//        ['super_admin']       -> Brand Command staff only (auth + admin gate)
export function registerModule(routes, { roles = [] } = {}) {
  const adminOnly = roles.includes("super_admin");
  const workspaceAdmin = roles.includes("workspace_admin");
  return (routes || []).map(({ path, component: C }) => {
    let guarded;
    if (adminOnly) {
      guarded = <RequireAuth><RequireSuperAdmin><C /></RequireSuperAdmin></RequireAuth>;
    } else if (workspaceAdmin) {
      guarded = (
        <RequireAuth><RequireBilling><RequireWorkspaceAdmin><C /></RequireWorkspaceAdmin></RequireBilling></RequireAuth>
      );
    } else {
      guarded = <RequireAuth><RequireBilling><C /></RequireBilling></RequireAuth>;
    }
    return <Route key={path} path={path} element={guarded} />;
  });
}
